import { useEffect, useState } from 'react';
import { useScsUrlParts } from './useScsUrlParts';
import { getVehicleRequestUrl } from '../../utils';
export const useVehicleUrl = (vehicleId) => {
    const scsUrlParts = useScsUrlParts();
    const [url, setUrl] = useState();
    useEffect(() => {
        if (vehicleId && scsUrlParts) {
            setUrl(getVehicleRequestUrl(scsUrlParts, vehicleId));
        }
    }, [scsUrlParts, vehicleId]);
    return url;
};
